import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';
import { Tier1 } from 'src/app/models/obs/tier1';
import { Tematic } from 'src/app/models/obs/tematic';
import { Tier3 } from 'src/app/models/obs/tier3';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { BridgeService } from 'src/app/services/util/bridge.service';
import { urlEndPoint } from 'src/app/common';

@Component({
  selector: 'app-scene',
  templateUrl: './scene.component.html',
  styleUrl: './scene.component.scss'
})
export class SceneComponent implements OnInit {
  idEvenType: string = '7';

  idT3: number = 0;
  t1: Tier1 = null;
  URL: string = urlEndPoint;
  t1Long: Tier1;
  t1Short: Tier1;
  t2: Tematic[];
  t3Long: Tier3[];
  t3Short: Tier3[];
  t3: Tier3;
  msg: Message;
  classCard: string = ''; // Cantidad de registros Tier3
  idSelected: number = 0;
  selectedItem: any;

  isDiv2020: boolean = false;

  constructor(
    private bridgeS: BridgeService,
    private t1s: Tier1Service,
    private t3s: Tier3Service) { }

  ngOnInit() {
    this.getT1Long(9);
    this.getT1Short(14);
    this.getLongTermForT1(9);
    this.getShortTermForT1(14);
    this.getTier1();
    // Suscripción al Subject de comunicación del observable de IdT3
    this.bridgeS.enviarIdObservable.subscribe(id => {
      this.idT3 = id;
    });

    this.cambioId(this.idT3);
    this.listClick(null, 0);

  }

  // Función de envío de mensaje
  cambioId(id: number) {
    this.bridgeS.enviarIdT3(id);
  }


  listClick(event, obj) {
    this.selectedItem = obj;
  }

  change(val) {
    this.isDiv2020 = val;
  }

  getT1Long(id: number) {
    this.t1s.getOne(id).subscribe(
      async res => {
        this.t1Long = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  getT1Short(id: number) {
    this.t1s.getOne(id).subscribe(
      async res => {
        this.t1Short = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  getLongTermForT1(id: number) {
    this.t3s.getByIdTier1(id).subscribe(
      async res => {
        this.t3Long = res['data'];
        //Agregado
      // Ordenar los objetos por la propiedad 'publication' de manera ascendente
      if (this.t3Long && this.t3Long.length > 0) {
        this.t3Long.sort((a, b) => {
          // Convertir las fechas de 'publication' a objetos Date para compararlas
          const dateA = new Date(a.publication).getTime();
          const dateB = new Date(b.publication).getTime();

          // Devolver la diferencia entre las fechas para ordenar de manera ascendente
          return dateA - dateB;
        });
      } else {
        console.log('No se encontraron datos o el atributo publication no está definido.');
      } //Aquí termina
        this.classCard = this.classedCards(this.t3Long.length);
        this.t3 = this.t3Long[0];
      },
      err => { this.msg = err; }
    );
  }

  getShortTermForT1(id: number) {
    this.t3s.getByIdTier1(id).subscribe(
      async res => {
        this.t3Short = res['data'];  
                //Agregado
      // Ordenar los objetos por la propiedad 'publication' de manera ascendente
      if (this.t3Short && this.t3Short.length > 0) {
        this.t3Short.sort((a, b) => {
          // Convertir las fechas de 'publication' a objetos Date para compararlas
          const dateA = new Date(a.publication).getTime();
          const dateB = new Date(b.publication).getTime();

          // Devolver la diferencia entre las fechas para ordenar de manera ascendente
          return dateA - dateB;
        });
      } else {
        console.log('No se encontraron datos o el atributo publication no está definido.');
      } //Aquí termina      
      },
      err => { this.msg = err; }
    );
  }

  classedCards(n: number) {
    let text: string = '';
    switch (n) {
      case 1: { text = 'col-sm-3'; break; }
      case 2: { text = 'col-sm-3'; break; }
      case 3: { text = 'col-sm-3'; break; }
      case 4: { text = 'col-sm-3'; break; }
      case 5: { text = 'col-sm-3'; break; }
      case 6: { text = 'col-sm-3'; break; }
      case 7: { text = 'col-sm-3'; break; }
      case 8: { text = 'col-sm-3'; break; }
      case 9: { text = 'col-sm-2'; break; }
      default: { text = 'col-sm-2'; break; }
    }
    return text;
  }

  clicked(obj: any, i: number) {
    this.selectedItem = obj;
    this.idSelected = i;
    this.t3Long.forEach((o, j) => {
      if (j == i) {
        this.t3 = o;
        this.cambioId(o.id);
      }
    });
  }

  getTier1() {
    this.t1s.getOne(14).subscribe(
      res=>{
        this.t1 = res['data'];       
      },
      err => { this.msg = err; }
    );
  }

}
